import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import styled from '@emotion/styled';
import { Box, List, ListItem, ListIcon, Stack } from '@chakra-ui/core';

const TextWrapper = styled.div`
    margin: 0rem auto;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const WordName = styled.em`
    font-style: italic;
`;

const AboutPage = () => (
    <Layout>
        <SEO title="About" />
        <TextWrapper>
            <Box fontSize="3xl" align="center">
                A New Approach
            </Box>
            <List spacing="20px" marginTop="20px">
                <ListItem>
                    <Stack direction="row">
                        <ListIcon icon="check-circle" color="#00FF00" />
                        <Box>
                            Local Lingo adds to your language course. It expands your vocabulary rather than teaching you the rules of the
                            language.
                        </Box>
                    </Stack>
                </ListItem>
                <ListItem>
                    <Stack direction="row">
                        <ListIcon icon="check-circle" color="#00FF00" />
                        <Box>
                            Set your level - as a beginners you'll learn <WordName>Coffee</WordName> but a higher level teaches{' '}
                            <WordName>Coffee Machine</WordName>. Experts learn <WordName>Coffee Tamper</WordName>.
                        </Box>
                    </Stack>
                </ListItem>
                <ListItem>
                    <Stack direction="row">
                        <ListIcon icon="check-circle" color="#00FF00" />
                        <Box>Similar words are grouped together, for example: Food and Drinks. This helps you remember them.</Box>
                    </Stack>
                </ListItem>
                <ListItem>
                    <Stack direction="row">
                        <ListIcon icon="check-circle" color="#00FF00" />
                        <Box>
                            Each lesson or test is personalised based upon how well you know each word. You can even indicate which words
                            you think are the most important and the ones you don't care about.
                        </Box>
                    </Stack>
                </ListItem>
                <ListItem>
                    <Stack direction="row">
                        <ListIcon icon="check-circle" color="#00FF00" />
                        <Box>
                            Language vocabulary varies between countries. Local Lingo allows you to select which country best suites you.
                        </Box>
                    </Stack>
                </ListItem>
                <ListItem>
                    <Stack direction="row">
                        <ListIcon icon="check-circle" color="#00FF00" />
                        <Box>
                            Provide your feedback, you might have a better suggestion for where you live. We'll continually improve with
                            your help.
                        </Box>
                    </Stack>
                </ListItem>
            </List>
        </TextWrapper>
    </Layout>
);

export default AboutPage;
